import { useContext } from 'react';
import UserContext from '../context/UserContext/UserContext';

interface AuthRoles {
  userCanWrite: () => boolean;
  userIsAdmin: () => boolean;
  userIsJapetoAdmin: () => boolean;
  userIsSuperAdmin: () => boolean;
}

function useAuthRoles(): AuthRoles {
  const { user } = useContext(UserContext);

  const userCanWrite = (): boolean => {
    return (
      !!user &&
      [
        'READ_WRITE',
        'ORGANISATION_ADMIN',
        'JAPETO_ADMIN',
        'SUPER_ADMIN'
      ].includes(user.role)
    );
  };

  const userIsAdmin = (): boolean => {
    return (
      !!user &&
      ['ORGANISATION_ADMIN', 'JAPETO_ADMIN', 'SUPER_ADMIN'].includes(user.role)
    );
  };

  const userIsJapetoAdmin = (): boolean => {
    return !!user && ['JAPETO_ADMIN', 'SUPER_ADMIN'].includes(user.role);
  };

  const userIsSuperAdmin = (): boolean => {
    return !!user && user.role === 'SUPER_ADMIN';
  };

  return {
    userCanWrite,
    userIsAdmin,
    userIsJapetoAdmin,
    userIsSuperAdmin
  };
}

export default useAuthRoles;
